export var DATE_LOCALE;
(function (DATE_LOCALE) {
    DATE_LOCALE["en"] = "en-GB";
    DATE_LOCALE["cs"] = "cs-CZ";
    DATE_LOCALE["da"] = "da-DK";
    DATE_LOCALE["de"] = "de-DE";
    DATE_LOCALE["es"] = "es-ES";
    DATE_LOCALE["fr"] = "fr-FR";
    DATE_LOCALE["hi"] = "hi-IN";
    DATE_LOCALE["it"] = "it-IT";
    DATE_LOCALE["ja"] = "ja-JP";
    DATE_LOCALE["ko"] = "ko-KR";
    DATE_LOCALE["nl"] = "nl-NL";
    DATE_LOCALE["id"] = "id-ID";
    DATE_LOCALE["no"] = "no-NO";
    DATE_LOCALE["pl"] = "pl-PL";
    DATE_LOCALE["pt"] = "pt-PT";
    DATE_LOCALE["ru"] = "ru-RU";
    DATE_LOCALE["sv"] = "sv-SE";
    DATE_LOCALE["th"] = "th-TH";
    DATE_LOCALE["tr"] = "tr-TR";
    DATE_LOCALE["uk"] = "uk-UA";
    DATE_LOCALE["zh"] = "zh-CN";
    DATE_LOCALE["vi"] = "vi-TV";
})(DATE_LOCALE || (DATE_LOCALE = {}));
//# sourceMappingURL=language-to-locales.js.map